

import Vue from 'vue'
import App from './App'
import router from './router'
import store from "../src/store/index"
import { sendConfigRequest } from "../static/utils/http"
import utils from "../static/utils/util"
import './css/iconfonts/iconfont.css';
import './css/top-filter.css';
import MyHeader from "./components/template/Header.vue"
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import Badge from 'vux/src/components/badge/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Group from 'vux/src/components/group/index.vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import XProgress from 'vux/src/components/x-progress/index.vue'


Vue.component('my-header', MyHeader)
Vue.component('actionsheet', Actionsheet)
Vue.component('alert', Alert)
Vue.component('badge', Badge)
Vue.component('cell', Cell)
Vue.component('check-icon', CheckIcon)
Vue.component('confirm', Confirm)
Vue.component('datetime', Datetime)
Vue.component('group', Group)
Vue.component('load-more', LoadMore)
Vue.component('picker', Picker)
Vue.component('popup', Popup)
Vue.component('popup-picker', PopupPicker)
Vue.component('previewer', Previewer)
Vue.component('scroller', Scroller)
Vue.component('search', Search)
Vue.component('selector', Selector)
Vue.component('swiper', Swiper)
Vue.component('swiper-item', SwiperItem)
Vue.component('swipeout', Swipeout)
Vue.component('swipeout-item', SwipeoutItem)
Vue.component('swipeout-button', SwipeoutButton)
Vue.component('tab', Tab)
Vue.component('tabbar', Tabbar)
Vue.component('tab-item', TabItem)
Vue.component('tabbar-item', TabbarItem)
Vue.component('toast', Toast)
Vue.component('x-header', XHeader)
Vue.component('x-img', XImg)
Vue.component('x-input', XInput)
Vue.component('x-number', XNumber)
Vue.directive('transfer-dom', TransferDom)
Vue.component('x-progress', XProgress)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin, { position: 'middle', type: 'text'})

Vue.use(utils)

Vue.config.productionTip = false

/*移除移动端页面点击延迟*/
const FastClick = require('fastclick')
FastClick.attach(document.body)
Vue.prototype.$sendConfigRequest = sendConfigRequest;

let cid = getSellerNoCurrent() 
store.state.cid = cid

router.beforeEach(function(to, from, next) {


if (!!cid) {
let toPath = to.path
let fromPath = from.path
let toFullPath = to.fullPath
let fromFullPath = from.fullPath
if (fromPath === '/') {
let href = getTopUrl()

if (href.indexOf('#/index') == -1) {
let time = new Date().getTime()
href = href.substr(0, href.indexOf('?cid'))
href = href + "#/index?cid=" + cid + "&time=" + time

window.location.replace(href)
}
}

if (toPath == fromPath && toPath == '/login' && store.state.permissions > 0) {
toPath = '/index'
router.replace('/index?' + href.substr(href.indexOf('?') + 1))
}

if (toPath == '/index' || toPath == '/sort' || toPath == '/shoppingcart' || toPath == '/my') {
if (toPath == '/index' && store.state.isFirstEnter) {
store.state.isTabbar = false
store.dispatch('getThemeConfig').then(() => {//获取商户主题配置信息
if (store.state.isHasLoading) {
setTimeout(() => {
store.state.isFirstEnter = false
store.state.isTabbar = true
}, store.state.loadingTime)
next()
} else {
setTimeout(() => {
store.state.isFirstEnter = false
store.state.isTabbar = true
next()
}, 1000)
}
})
} else {
store.state.isFirstEnter = false
store.state.isTabbar = true
next()
}
} else {
store.state.isFirstEnter = false
store.state.isTabbar = false
next()
}
} else {
store.state.isTabbar = false
store.state.isFirstEnter = false
Vue.$vux.alert.show({
title: '提示',
content: '信息获取失败，请关闭商城重新进入',
onHide() {
WeixinJSBridge.invoke("closeWindow", {}, function(e) {})
}
})
next(false)
}
});

router.afterEach(function(to, from, next) {
blurScrollBody()
initBtnAutoStyle()
})

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: {
App
},
template: '<App/>'
})

/*解决input和textarea失去焦点页面没有还原；键盘弹出遮住input框*/
function blurScrollBody() {
document.querySelector('body').addEventListener('blur', function(e) {
let tar = e.target
if (tar.nodeName.toLowerCase() =='input' || tar.nodeName.toLowerCase() =='textarea') {
setTimeout(function() {
let tagName = document.activeElement.tagName
if (!(tagName.toLowerCase() == 'input' || tagName.toLowerCase() == 'textarea')) {
document.querySelector('body').scrollTop = tar.scrollHeight
}
}, 20)
}
}, true)
}

/*给btn加上默认点击样式，需要加上auto-btn-tap-style的class*/
function initBtnAutoStyle() {
document.querySelector('body').addEventListener('click', function(e) {
let eleClassList = e.target.classList
if (eleClassList.contains('auto-btn-tap-style')) {
eleClassList.add('btn-opacity')
setTimeout(() => {
eleClassList.remove('btn-opacity')
}, 200)
}
})
}


// WEBPACK FOOTER //
// ./src/main.js